// extracted by mini-css-extract-plugin
export default {"feedActionContent":"FeedActionIcon_feedActionContent__1USWm"};